const OPTION_TYPES = ['select', 'radio']

const isEmpty = (value) => value === null || value === undefined || value === ''

/**
 * The value a form item starts with on the booking form (AIRLST-6105). It mirrors the registration
 * form (`live/registration/prefill.js` and `HandlesFormSubmission::applyDefaultToField`): a value the
 * guest already has wins, then the item's query parameter, then its default value. The landing page
 * captures query parameters in PHP, which turns dots in a parameter name into underscores, so the
 * configured name is matched the same way.
 *
 * @param {Object} item - Form item definition from the Checkout API
 * @param {*} value - The value the guest already has
 * @param {Object<string, *>} queryParameters - Query parameters the landing page captured
 * @returns {*}
 */
export const resolveInitialFieldValue = (item, value, queryParameters = {}) => {
  const settings = item?.settings
  if (!isEmpty(value) || !settings) return value ?? null

  if (settings.prefilled_from_query && settings.query_param) {
    const queryValue =
      queryParameters?.[settings.query_param.replace(/\./g, '_')]

    if (
      typeof queryValue === 'string' &&
      queryValue !== '' &&
      (!OPTION_TYPES.includes(item.type) ||
        (item.field?.options ?? []).some(
          (option) => option.is_visible && option.key === queryValue,
        ))
    ) {
      return queryValue
    }
  }

  return settings.default_value ?? value ?? null
}
